// SPDX-License-Identifier: AGPL-3.0-or-later

import {remFromPx} from '@app/features/theme/layout/RemFromPx';
import {BoostGemBadgeIcon} from '@app/features/user/components/badges/LafonBadgeIcons';
import type React from 'react';

interface GuildBoostBadgeIconProps {
	className?: string;
	size?: number;
}

/** Guild boost badge icon (bundled SVG, renders instantly). */
export const GuildBoostBadgeIcon: React.FC<GuildBoostBadgeIconProps> = ({className, size = 14}) => {
	const dimension = remFromPx(size);
	return (
		<BoostGemBadgeIcon
			className={className}
			size={size}
			style={{width: dimension, height: dimension, display: 'block', flexShrink: 0}}
		/>
	);
};
